export const PLAN_FORM = "configPlanForm";
export const DELETE_SUBSCRIPTION_BILLING_FORM = "configDeleteSubscriptionBillingForm";